import { render, staticRenderFns } from "./UnreadMessageIcon.vue?vue&type=template&id=7c5ec344"
import script from "./UnreadMessageIcon.vue?vue&type=script&lang=js"
export * from "./UnreadMessageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports